import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const AZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AZ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#AF0100"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3CA5D9"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#73BE4A"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          d="M8.498 3.896c.583-.001 1.294.317 1.498.771-.013-.007-.66-.351-1.393-.186a1.53 1.53 0 0 0-1.215 1.51c-.007.777.52 1.307 1.193 1.462.666.154 1.369-.208 1.384-.216-.087.242-.506.808-1.386.81-1.098.003-2.347-.743-2.335-2.054.011-1.265 1.169-2.093 2.254-2.097Zm1.334 1.682.716.015-.57.432.206.685-.587-.408-.588.408.208-.685-.572-.432.716-.015.236-.677.235.677Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
